module.exports = __webpack_public_path__ + "static/media/lg-hunger.5c27f44a.jpg";